import React from 'react';

import { Modal } from '../../../../components';

import { CryingFace } from '../../../../assets/svg-image/modal';

import {
  OkeyBtn,
} from './Styles';
import SquadBoldText from '../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import SquadSemiBoldText from '../../../../components/Text/SquadSemiBoldText';
import RowCenter from '../../../../components/Layout/RowCenter';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import { closeBlack } from '../../../../assets/Base64Image';
import Button from '../../../../components/Button';

const FreeTimeExpiredModal: React.FC<Props> = ({
  onClose,
  onConfirm,
  isEnglish,
}) => {
  return (
    <Modal
      style={{ width: 338, minWidth: 'unset', padding: 'unset', textAlign: 'center', paddingBottom: 26, borderRadius: 42 }}
    >
      {/* 图标 */}
      <div>
        <img src={CryingFace} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </div>
      {/* 关闭图标 */}
      <Button
        onClick={() => onClose()}
        style={{ padding: 10, width: 30, height: 30, marginLeft: 'auto', marginRight: 10, marginTop: -10 }}
      >
        <img src={closeBlack} style={{ width: 14, height: 14 }} />
      </Button>

      {
        isEnglish ? (
          <SquadBoldText fontSize={22} marginTop={5}>
            Free time expired
          </SquadBoldText>
        ) : (
          <PingFangSemiBoldText fontSize={22} marginTop={5}>
            免费时间已过期
          </PingFangSemiBoldText>
        )
      }
      <RowCenter>
        {
          isEnglish ? (
            <SquadRegularText fontSize={16} lineHeight={21} textAlign={'center'} marginTop={15} width={292}>
              <SquadSemiBoldText fontSize={16} lineHeight={21} isSpan={true}>You have ONE hour to collect your food from our lockers for free.</SquadSemiBoldText> This time has lapsed, please complete a payment to unlock your order.
            </SquadRegularText>
          ) : (
            <PingFangRegularText fontSize={16} lineHeight={21} textAlign={'center'} marginTop={15} width={292}>
              <PingFangMediumText fontSize={16} lineHeight={21} isSpan={true}>你有一小时的时间可以免费从我们的储物柜中领取你的食物。</PingFangMediumText> 如果这段时间已过，请完成支付以解锁你的订单。
            </PingFangRegularText>
          )
        }
      </RowCenter>

      <OkeyBtn onClick={() => onConfirm()}>
        {
          isEnglish ? (
            <SquadBoldText fontSize={18} color={'#FFFFFF'}>
              Unlock food order
            </SquadBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
              解锁订单
            </PingFangSemiBoldText>
          )
        }
      </OkeyBtn>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  onConfirm: () => void;
  isEnglish: boolean;
}

export default FreeTimeExpiredModal;
